import axios from "axios";

export default axios.create({
  baseURL: `http://localhost/api.synapsepixel/`,
  headers: {
    'Content-Type': 'application/json',
  },
//baseURL: `https://pb6mcfks571yxbdn-api.yanilyCompta/`,
});
